import React, { useState, useRef, useEffect } from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { selectUserState } from "../../selectors/application";
import Heading from "../../elements/heading";
import BodyText from "../../elements/body-text";
import TestDriveForm from "../../sections/test-drive-form";
import SuggestedArticles from "../../sections/suggested-articles";
import { apiAsia } from "../../utils/api-asia";
import { getCommentsCountryOptions } from "../../services/siteService";
import webcookie from "../../utils/webcookie";
import { S_PRIVACY_ID, S_COOKIE_VERSION, S_LANG, webStorage } from "../../utils/webStorage";
import gsap from 'gsap';
import { gtag } from "../../utils";
import { mobileIs, loadScrollMagic, getQueryVariable, getOverallSettingsClasses } from "../../utils/siteUtils";
import "./style.scss";
const config = require("../../temp/config");
let CountryCode = null;
const TestDrive = ({ fields, rendering, page }) => {
  const isAR = page?.fields?.rtl?.value;
  const titleEl = useRef(null);
  const contentEl = useRef(null);
  const testdriverTextEl = useRef(null);
	const isMobile = mobileIs();
  /*Redux start*/
  const user = useSelector(selectUserState);
  /*Redux end*/
  const {
    consent,
    backgroundColor,
    backgroundImage,
    backgroundImageMobile,
    submittedBody,
    headingBody,
    headingType,
    headingFormBody,
    headingFormType,
    submittedHeadingType,
    submittedheadingBody,
    body,
    nameLabel,
    nameMissingMessage,
    appellations,
    appellationLabel,
    appellationMissingMessage,
    phoneCodeLabel,
    phoneCodeMissingMessage,
    phoneLabel,
    phoneWarningMessage,
    phoneMissingMessage,
    emailLabel,
    emailMissingMessage,
    emailWarningMessage,
    countryLabel,
    countryMissingMessage,
    cityLabel,
    cityMissingMessage,
    dealerLabel,
    dealerMissingMessage,
    nodealer,
    captcha,
    defaultError,
    ctaName,
    iconName,
    colorScheme,
    disclaimer,
    checkBoxLabel,
    subscribeCheckBoxLabel,
    subscribeIsChecked,
    suggestedArticlesHeadingType,
    suggestedArticlesHeadingBody,
    suggestedArticlesIcon,
    articles,
    title,
    content
  } = fields;
  const { language, areaCode } = rendering.fields;
  let lang = language?.fields?.phrase?.value ? language?.fields?.phrase?.value : 'en';
  webStorage.set(S_LANG, lang);
  let areacode = areaCode?.value;

  const currentComponent = useRef();
  const appellationOptions = appellations.map(x => ({
    code: x.fields.phrase.value,
    value: x.fields.text.value
  }));
  let submitting = false;
  const [countryOptions, setCountryOptions] = useState([]);
  const [countrySelected, setCountrySelected] = useState();
  const [cityError, setCityError] = useState(null);
  const [cityOptions, setCityOptions] = useState([]);
  const [citySelected, setCitySelected] = useState();
  const [country, setCountry] = useState(null);
  const [dealerOptions, setDealerOptions] = useState([]);
  const [dealerSelected, setDealerSelected] = useState();
  const [phoneCodeSelected, setPhoneCodeSelected] = useState();
  const [phoneCodeOptions, setPhoneCodeOptions] = useState([]);
  const [testDriveIsSubmitted, setTestDriveIsSubmitted] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [defaultCode, setDefaultCode] = useState('');
  const [latlng, setLatlng] = useState(null);
  const [currentPos, setCurrentPos] = useState(false);
  const testdriverEl = useRef(null);
  const init = async () => {
    // const countries = await getCommentsCountryOptions();
    // setCountryOptions(countries);
    getLag()
    getCountry()
	navigator.geolocation.getCurrentPosition(function() {
	  getIpCode();
	  setCurrentPos(true);
	})
  };
  const getCountry = async () => {    
    apiAsia.form.country({language: lang, areaCode: areacode}).then(res => {
      if (!!res[0]) {
        let countrtList = []
        let codeList = []
        res[0].forEach(v=>{
          countrtList.push({
            code : v.countryCode,
            value : v.countryName
          })
          codeList.push({
            code : v.countryCode,
            value: `+${v.phoneAreaCode}`,
            values : ` (${v.countryName})`
          })
        })
        codeList.push({
          code:'editSelect',
          value: 'Other',
        })
        setCountryOptions(countrtList);
        setPhoneCodeOptions(codeList)
				getCountryCode(countrtList);
      }
    })
    .catch(err => {
      console.log(err)
    });
  };
	const getCountryCode = async (countrtList) => {
	  const [res, ex] = await apiAsia.dealer.getCountryCode({});
	  if(countrtList && countrtList.length > 0) {
	    countrtList.forEach((item, index) => {
	      if(item.code === res.countryCode) {
	        setCountry(item);
	      }
	    })
	  }
	}
  useEffect(() => {
  	if (country && currentPos) {
  	  setCountrySelected(country);
  	}
  }, [country, currentPos]);
  const getCities = async code => {
    let params = {
      language: lang,
      countryCode: code
    }
    apiAsia.form.city(params).then(res => {
      if (!!res[0]) {
        let data = res[0].map(v=>{
          v.code = v.cityCode
          v.value = v.cityName
          return v
        })
        setCityOptions(data);
        setCitySelected(data[0]);
        getDealer(code, data[0].code);
      }else{
        setCityOptions([]);
      }
    })
    .catch(err => {
      setCityError(err);
      setCityOptions([]);
    });
  };
  const getIpCode = async () => { 
    apiAsia.form.ip({language: lang}).then(res => {
      if (!!res[0]) {
        setPhoneCodeSelected({
          code : res[0].countryCode,
          value: `+${res[0].phoneAreaCode}`,
          values : ` (${res[0].countryName})`
        })
      }
    })
    .catch(err => {
      console.log(err)
    });
  }
  const getLag = async e => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        e => {
          setLatlng(e?.coords)
        },
        ex => {
          console.error(ex);
        }
      );
    }
  };
  const getDealer = async (countryCode, cityCode) => {
    // let driveType = getQueryVariable('driveType')
    let params = {
      language: lang,
      regionCode: null,
      cityCode: cityCode,
      countryCode: countryCode,
      longitude: latlng?.longitude,
      latitude: latlng?.latitude,
      // driveType: driveType ? driveType : null
      driveType: 0 // 试驾页只获取售前类型经销商
    }
    apiAsia.form.dealer(params).then(res => {
      if (!!res[0]) {
        let data = []
        res[0].forEach((v,index)=>{
          let obj = {
            code : v.networkCode,
            value : v.name,
            id:  v.id
          }
          if(latlng){
            obj.otherValue = v.distance.toFixed(1) + 'km'
          }
          data.push(obj)
        })
        setDealerOptions(data);
        setDealerSelected(data[0]);
        let delaerCode = getQueryVariable('delaerCode')
        if(data && data.length > 0) {
          data.forEach((item) => {
            if(item.id === delaerCode) {
              setDealerSelected(item)
            }
          })
        }
      }
    })
  };
  const form = {
    heading: {
      text: headingFormBody,
      type: headingFormType
    },
    name: {
      maxLength: 25,
      label: nameLabel.value,
      value: user?.firstName,
      missingMessage: nameMissingMessage.value
    },
    appellation: {
      placeholder: appellationLabel.value ?? "Appellation",
      options: appellationOptions,
      value: appellationOptions.length > 0 ? appellationOptions[0].code : null,
      missingMessage: appellationMissingMessage.value
    },
    phoneCode: {
      placeholder: phoneCodeLabel.value ?? "Code",
      missingMessage: phoneCodeMissingMessage.value,
      options: phoneCodeOptions,
      selectedOption: phoneCodeSelected,
      async onChange(value) {
        setPhoneCodeSelected(value);
      }
    },
    phone: {
      label: phoneLabel.value,
      value: user?.mobileNo,
      missingMessage: phoneMissingMessage.value,
      warningMessage: phoneWarningMessage.value
    },
    email: {
      type: "email",
      label: emailLabel.value,
      value: user?.email,
      missingMessage: emailMissingMessage.value,
      warningMessage: emailWarningMessage.value
    },
    country: {
      placeholder: countryLabel.value ?? "Country",
      missingMessage: countryMissingMessage.value,
      options: countryOptions,
      selectedOption: countrySelected,
      async onChange(value) {
        setCountrySelected(value);
        getCities(value.code)
        CountryCode = value.code;
      }
    },
    city: {
      placeholder: cityLabel.value ?? "City",
      options: cityOptions,
      selectedOption: citySelected,
      missingMessage: cityMissingMessage.value,
      onChange(value) {
        setCitySelected(value);
        getDealer(CountryCode, value.code);
      }
    },
    dealer: {
      placeholder: dealerLabel.value ?? "Dealer",
      options:dealerOptions,
      selectedOption: dealerSelected,
      missingMessage: dealerMissingMessage.value,
      nodealer: nodealer.value,
      async onChange(value) {
        setDealerSelected(value);
      }
    },
    button: {
      buttonText: ctaName.value,
      colorScheme: colorScheme,
      iconName: iconName
    },
    disclaimer: disclaimer.value,
    hasError: hasError,
    checkbox: {
      label: checkBoxLabel.value
    },
    subscribecheckbox: {
      label: subscribeCheckBoxLabel.value,
      subscribeIsChecked: subscribeIsChecked.value
    },
    hasCaptcha: captcha.value
  };
  const onScroll = () => {
    let pageHeight = document.documentElement.clientHeight || document.body.offsetHeight || document.documentElement.offsetHeight;
    if (testdriverEl?.current?.getBoundingClientRect()?.top < pageHeight) {
      gtag('event', 'testdrive_exp', {
        'page_title': page?.name
      });
    }
  };
  const suggestedArticles = {
    heading: {
      text: suggestedArticlesHeadingBody,
      type: suggestedArticlesHeadingType
    },
    linkIcon: suggestedArticlesIcon,
    articles: articles.map(item => ({
      title: item?.fields?.links?.value?.text,
      link: item?.fields?.links
    }))
  };
  const onSubmit = async data => {
    if (submitting) return;
    submitting = true;
    webStorage.set(S_LANG, lang);
    let body = {
      intentionModelCode: page?.fields?.CarModel?.fields?.code?.value,
      customerName: data.name,
      customerPhone: `+${data.phoneAreaCode} ${data.phoneNumber}`,
      customerEmail: data.email,
      countryCode: data.country,
      networkCode: data.networkCode,
      networkName:  data.networkName,
      activityId: page?.fields?.ActivityId?.value,
      city: data.city,
      customerSex: data.appellation,
      lang: lang,
      CookieCode: webcookie.getCookie('code'),
      CookieVersion: webStorage.get(S_COOKIE_VERSION)
    };
    if(webStorage.get(S_PRIVACY_ID)){
      body.PrivacyId = webStorage.get(S_PRIVACY_ID)
    } else {
        const [data, ex] = await apiAsia.sitecore.item({
          id: config.webSettings.cookieId,
          lang
        });
        var reg = /^\{/gi;
        var reg2 = /\}$/gi;
        data.privacyPolicy = data.privacyPolicy.replace(reg, '')
        data.privacyPolicy = data.privacyPolicy.replace(reg2, '')
        body.PrivacyId = data.privacyPolicy.toLowerCase()
    }
    const [res, ex] = await apiAsia.testDrive.submit(null, body);
    if (ex) {
      setHasError(true);
      setErrorMessage(defaultError?.value || res.message);
    }
    if(data.subTermsAgreed){
      const [subres, subex] = await apiAsia.form.submit(null, {
        Email: data.email,
        countryCode:  data.country,
        Language: lang,
      });
      if (ex) {
        setErrorMessage(defaultError?.value || subres.message);
      }
    }
    gtag('event', 'testdrive_clk', {
      'page_title': page?.name,
      'button_name': ctaName?.value
    });
    submitting = false;
    global.history.pushState(null, null, '?result=true');
    setTestDriveIsSubmitted(true);
  };

  const testDriveMainClasses = classNames( "test-drive-main");
  const testDriveClasses = classNames(getOverallSettingsClasses(fields), "test-drive", "grid");

  /* background image will override background color */
  let backgroundStyle = {};
  if (backgroundColor) {
    backgroundStyle = {
      backgroundColor: backgroundColor.fields.key.value
    };
  }
  if (backgroundImage.value.src) {
    backgroundStyle = {
      backgroundImage: `linear-gradient(241.15deg, rgba(0, 0, 0, 0.23) 28.78%, #000000 77.31%), url(${isMobile? backgroundImageMobile.value.src : backgroundImage.value.src})`,
      WebkitBackgroundSize: "cover"
    };
  }
  useEffect(() => {
    if(global.location.search.indexOf('result')!=-1){
      var url=global.location.href;
      if(url.indexOf("?")!=-1){
        url = url.replace(/(\?|#)[^'"]*/, '');
        global.history.pushState({},0,url);
      }
    }
    init().then();
    let ScrollMagic, controller, scene, scene2, scene3, tl, tl2;
    ScrollMagic = loadScrollMagic();
    tl2 = gsap.timeline({paused: true});
    tl2.to(titleEl.current,0.8,{
      opacity: 1,
      translateY: 0
    },'first')
    .to(contentEl.current,0.8,{
      opacity: 1,
      translateY: 0,
      delay: 0.3
    },'first')

    tl = gsap.timeline({paused: true});
    tl
      .to(currentComponent.current,0.8,{
        marginTop: 0,
      },'first')
      .to(currentComponent.current,0.8,{
        backgroundPosition: '0 0',
      },'first')
    controller = new ScrollMagic.Controller();
    scene = new ScrollMagic.Scene({
      triggerElement: currentComponent.current,
      triggerHook: 'onEnter',
      
    })
    .addTo(controller);
    scene.on("progress", function(event) {
      let ep = event.progress;
      if(ep>0){
        tl.play()
      }
      if(ep == 0){
        tl.reverse()
      }
    })
    scene2 = new ScrollMagic.Scene({
      triggerElement: testdriverEl.current,
      triggerHook: 'onLeave',
      duration: `100%`
    })
    // .setPin(testdriverEl.current)
    .addTo(controller);
    
    scene3 = new ScrollMagic.Scene({
      triggerElement: testdriverTextEl.current,
      triggerHook: 'onEnter',
      
    })
    .addTo(controller);
    scene3.on("progress", function(event) {
      let ep = event.progress;
      if(ep>0){
        tl2.play()
      }
      if(ep == 0){
        tl2.reverse()
      }
    });
    window.addEventListener("scroll", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
      scene.destroy(true);
      scene = null;
      scene2.destroy(true);
      scene2 = null;
      scene3.destroy(true);
      scene3 = null;
      controller.destroy(true);
      controller = null;
    };
  }, []);
  return (
    <div className={testDriveMainClasses} ref={testdriverEl} datasourceid={rendering.dataSource}>
      {/* <div className="testdriver-text" ref={testdriverTextEl}>
        <div ref={titleEl} className="title">
          <BodyText html={title.value} />
        </div>
        <div ref={contentEl} className="content">
          <BodyText html={content.value} />
        </div>
      </div> */}
      <div style={backgroundStyle} className={testDriveClasses} ref={currentComponent}>
        <div className="left">
          {!testDriveIsSubmitted && (
            <React.Fragment>
              {headingBody && <Heading html={headingBody} type={headingType} className="title" typographyClass="type-h1" />}
              <BodyText html={body.value} />
              <div className="test-drive-form-root">
                <TestDriveForm {...{ ...form, hasError, errorMessage: errorMessage, onSubmitForm: data => onSubmit(data), lang }} />
              </div>
            </React.Fragment>
          )}

          {testDriveIsSubmitted && (
            <React.Fragment>
              {submittedheadingBody && <Heading html={submittedheadingBody} type={submittedHeadingType} className="title" typographyClass="type-h1" />}
              <BodyText html={submittedBody.value} />
            </React.Fragment>
          )}
        </div>
        {testDriveIsSubmitted && suggestedArticles && <SuggestedArticles {...suggestedArticles} className="right" />}
      </div>
      
    </div>
  );
};

TestDrive.propTypes = {
  rendering: PropTypes.shape({ dataSource: PropTypes.string }),
  fields: PropTypes.shape({
    paddingAboveBottom: PropTypes.object,
    paddingAboveTop: PropTypes.object,
    backgroundColor: PropTypes.object,
    backgroundImage: PropTypes.object,
    backgroundImageMobile: PropTypes.object,
    submittedBody: PropTypes.object,
    headingBody: PropTypes.object,
    headingType: PropTypes.object,
    headingFormBody: PropTypes.object,
    headingFormType: PropTypes.object,
    submittedHeadingType: PropTypes.object,
    submittedheadingBody: PropTypes.object,
    body: PropTypes.object,
    suggestedArticles: PropTypes.object,
    emailRequiredError: PropTypes.object,
    colorScheme: PropTypes.object,
    firstNameLabel: PropTypes.object,
    firstNameRequiredError: PropTypes.object,
    lastNameLabel: PropTypes.object,
    lastNameRequiredError: PropTypes.object,
    phoneNumberLabel: PropTypes.object,
    phoneNumberRequiredError: PropTypes.object,
    storeLocationLabel: PropTypes.object,
    storeLocationErrorLabel: PropTypes.object,
    CtaName: PropTypes.object,
    iconName: PropTypes.object,
    disclaimer: PropTypes.object,
    emailTipText: PropTypes.object,
    checkBoxLabel: PropTypes.object,
    subscribeCheckBoxLabel: PropTypes.object,
    captcha: PropTypes.object,
    phoneAreaLabel: PropTypes.object
  })
};

TestDrive.defaultProps = {
  suggestedArticles: { articles: [] }
};
export default TestDrive;
